module.exports = {
	MajorTeaserArea: require('./MajorTeaserArea.jsx'),
	HeroTeaserArea: require('./HeroTeaserArea.jsx'),
	MinorTeaserArea: require('./MinorTeaserArea.jsx'),
	Teaser: require('./Teaser')
};



/** WEBPACK FOOTER **
 ** ./app/components/Teaser/index.js
 **/